<div class="p-fluid p-dialog-content">
  <h3>{{ isEditMode ? 'Edit Project' : 'Create New Project' }}</h3>
  <form [formGroup]="projectForm" (ngSubmit)="onSave()" id="projectForm">
    <div class="p-field">
      <label for="name">Project Name*</label>
      <input
        id="name"
        type="text"
        pInputText
        formControlName="name"
        placeholder="Enter project name"
        aria-required="true"
        [attr.aria-invalid]="projectForm.controls['name'].invalid && (projectForm.controls['name'].dirty || projectForm.controls['name'].touched)"
        aria-describedby="name-error">
      <small
        id="name-error"
        *ngIf="projectForm.controls['name'].invalid && (projectForm.controls['name'].dirty || projectForm.controls['name'].touched)"
        class="p-error">
        Project name is required.
      </small>
    </div>

    <div class="p-field">
      <label for="description">Description</label>
      <textarea
        id="description"
        pInputTextarea
        formControlName="description"
        rows="4"
        placeholder="Enter project description (optional)"
        aria-describedby="description-help"></textarea>
      <small id="description-help" class="form-text text-muted">
        Provide a brief description of your project.
      </small>
    </div>
  </form>
</div>

<div class="p-dialog-footer">
  <button
    pButton
    type="button"
    label="Cancel"
    icon="pi pi-times"
    class="p-button-text"
    (click)="onCancel()"
    aria-label="Cancel creating project"></button>
  <button
    pButton
    type="submit"
    form="projectForm"
    [label]="isEditMode ? 'Update Project' : 'Create Project'"
    icon="pi pi-check"
    [disabled]="!projectForm.valid"
    [attr.aria-label]="isEditMode ? 'Update project' : 'Create new project'"></button>
</div>
